export type AnalyticsEvent =
  | "hero_booking_click"
  | "service_booking_click"
  | "new_client_booking_click"
  | "final_booking_click"
  | "sms_click"
  | "language_switch"
  | "faq_interaction";

declare global {
  interface Window {
    lumaAnalytics?: (event: AnalyticsEvent, metadata?: Record<string, string | number | boolean>) => void;
  }
}

export function track(event: AnalyticsEvent, metadata?: Record<string, string | number | boolean>) {
  window.lumaAnalytics?.(event, metadata);
  if (import.meta.env.DEV) console.info("[analytics]", event, metadata ?? {});
}
